<template>

  <div class="vflex height-100">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Invitations') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('Invite new member') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort
                  field="email"
                  :value="sort"
                  @input="setSort">{{ $t('Email') }}</th-sort>
                <th-sort
                  field="role_id"
                  :value="sort"
                  @input="setSort">{{ $t('Role') }}</th-sort>
                <th-sort
                  field="created_at"
                  :value="sort"
                  @input="setSort">{{ $t('Created at') }}</th-sort>
                <th class="text-truncate">Ações</th>
              </tr>
            </thead>
            <tbody>
              <MemberInviteItem
                v-for="(memberInvite, index) in memberInvites"
                :key="index"
                :value="memberInvite"
                @deleted="loadData();" 
                @saved="loadData(paginate.page);" />
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <MemberInviteForm
        v-if="modal_select"
        :initMemberInvite="modal_select" 
        @hideModal="hideModal ()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page);" />

    </div>

  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import MemberInviteForm from './MemberInviteForm'
import MemberInviteResendInvite from './MemberInviteResendInvite'
import Paginaty from '@/components/Paginaty/Paginaty'
import MemberInviteItem from './MemberInviteItem'

export default {
  name: 'MemberInvite',
  components: {
    ThSort,
    MemberInviteForm,
    MemberInviteResendInvite,
    Paginaty,
    MemberInviteItem
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      sort: 'email'
    }
  },
  computed: {
    memberInvites () {
      return this.$store.getters.getMemberInvites
    },
    paginate () {
      return this.$store.getters.getMemberInvitesPaginate
    },
    currentRoute () {
      return this.$route.path
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /* loadData  */
    loadData (page) {
      this.loading = true

      const params = {
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectMemberInvites', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /* modal  */
    showCreateModal () {
      this.modal_select = {}
    },
    hideModal () {
      this.modal_select = false
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.photo {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  margin: -20px 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/Member/MemberInvite.vue